var map = {
	"./default.png": "d39f",
	"./dsfhss.png": "f8d4",
	"./hsddgl.png": "b17e",
	"./mdsj.png": "6a57",
	"./sytb.png": "94eb",
	"./sytb_hover.png": "f3c6",
	"./xtgl.png": "d176",
	"./zdgl.png": "f39e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "754c";